<template>
	<aside class="filter" id="filter" :class="showfilters ? 'open' : null">
		<div class="filter-header">
			<h2>Filter</h2>
			<a href="javascript:void(0)" class="js-filter-clear filter-clear hide-mobile" v-on:click="clearFilters()">clear all filters</a>
			<i class="icon icon-close filter-close hide-desktop" v-on:click="updateShowFilters"></i>
		</div>
		<div class="filters" id="filters">
			<div class="filter-section">

				<a href="javascript:void(0)" class="js-filter-clear filter-clear hide-desktop" v-on:click="clearFilters()">clear all filters</a>
				<h3>Special Type</h3>
				<ul class="filters-categories input-group">

					<li class="category">
						<div class="form-group form checkox-input">
							<input id="mysupplier" type="checkbox" v-model="filters.isMySupplier" value="filters.isMySupplier"></input>
							<label for="mysupplier">My Suppliers</label>
						</div>
					</li>
					<li class="category">
						<div class="form-group form checkox-input">
							<input id="atshowonly" type="checkbox" v-model="filters.isAtShowOnly" value="filters.isAtShowOnly"></input>
							<label for="atshowonly">At Show Only</label>
						</div>
					</li>

				</ul>
			</div>

			<div class="filter-section">
				<div class="form-group select-input">
					<label for="promotion-types" class="label-large">Promotion Type</label>
					<select id="promotion-types" class="form-control" v-model="filters.promotionTypes">
						<option value="" disabled>
							Select an Option
						</option>
						<option v-for="promotion in promotiontypes" :value="promotion.ID">
							{{promotion.Name}}
						</option>

					</select>
				</div>
			</div>
			<div class="filter-section">

				<div class="form-group select-input">
					<label for="sortBy" class="label-large">Sort By</label>
					<select id="sortBy" class="form-control" v-model="filters.sortBy">
						<option v-for="order in sortBy" :value="order.param">
							{{order.displayName}}
						</option>
					</select>
				</div>

				
			</div>
			<div class="filter-section">

				<h3>Category</h3>
				<ul class="filters-categories input-group">

					<li class="category" v-for="category in categoryfilters">
						<div class="form-group form checkbox-input">
							<input :id="'filter-' + category.ID" type="checkbox" v-model="filters.categories" :value="category.ID"></input>
							<label :for="'filter-' + category.ID">{{category.Name}}</label>
						</div>
					</li>

				</ul>
			</div>
		</div>
		<div class="filter-actions" :class="filterActionsStuck ? 'static' : ''">
			<button class="btn" v-on:click="applyFilters()">Apply Filters</button>
			<a href="javascript:void(0)" class="js-filter-clear hide-mobile" v-on:click="clearFilters()">Clear Filters</a>
		</div>
	</aside>

</template>


<script>
	export default {
		data: function () {
			return {
				filterActionsStuck: false,
				styleObject: {},
				categoryfilters: [],
				sortBy: [{ param: 'supplier', displayName: 'Supplier' }, { param: 'endingFirst', displayName: 'Ending First' }],
				promotiontypes: [],
				isAtShowOnly: false,
				isMySupplier: false,
				filters: {
					sortBy: 'supplier',
					promotionTypes: '',
					isAtShowOnly: false,
					isMySupplier: false,
					categories: [],
				},
			}
		},
		props: {
			showfilters: {
				type: Boolean,
				default: () => false
			},

		},
		watch: {
			showfilters: function (newVal) {
				this.showfilters = newVal;

				let body = document.getElementsByTagName("BODY")[0];

				if (newVal === true) {
					body.classList.add('collapse-shown');
					body.classList.remove('collapse-hide');
				}
				else {
					body.classList.add('collapse-hide');
					body.classList.remove('collapse-shown');
				}
			}

		},

		mounted() {
			this.promotiontypes = window.promotiontypes;
            this.categoryfilters = window.categoryfilters;

            const filterData = JSON.parse(sessionStorage.getItem('specialsFilters'));

            if (filterData) {
                this.filters = filterData;
                this.applyFilters();
            }
			
			$(window).on('scroll', e => { this.stickFilterActions() });
		},


		methods: {

			stickFilterActions() {
				let $stickyElem = $('.filter-actions');
				let $filters = $('#filters');
				let filterOffset = Math.round($filters.offset().top);
				let filterHeight = $filters.outerHeight();
				let stickyHeight = $stickyElem.outerHeight();
				let viewHeight = $(window).height();
				let totalHeight = filterHeight + (stickyHeight*2);

				$('.filter + .content-wrapper-main').css('minHeight', totalHeight);

				let offset = filterOffset + filterHeight + stickyHeight - $(window).scrollTop();

				if ((offset <= viewHeight) && !this.filterActionsStuck) {
					this.filterActionsStuck = true;
				}
				if ((offset > viewHeight) && this.filterActionsStuck) {
					this.filterActionsStuck = false;
				}
			},
			applyFilters() {

				// convert for api call
				let formatFilters = Object.assign({}, this.filters);

				// encode strings
				formatFilters.promotionTypes = formatFilters.promotionTypes;
				formatFilters.categories = formatFilters.categories;

                this.$emit('setspecialsfilter', formatFilters);
				this.updateShowFilters();
			},
			clearFilters() {
				this.filters.promotionTypes = '';
				this.filters.categories = [];
				this.filters.sortBy = 'supplier';
				this.filters.isAtShowOnly = false;
				this.filters.isMySupplier = false;

				this.$emit('clearfilters');
				this.applyFilters();
				this.$emit('selectallspecials');
			},
			updateShowFilters() {
				this.$emit('updateshowfilters', false);
			}
		}
	}

</script>